module.exports = __webpack_public_path__ + "img/t2-c20.361ab06d.png";